import React from 'react';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

import { EReportsTabs } from '../../types';

interface TabsProps {
    activeTab: EReportsTabs;
    onTabChange: (value: EReportsTabs) => void;
}

const ReportsTabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
    const handleChange = (value: string) => {
        onTabChange(value as EReportsTabs);
    };

    return (
        <Tabs value={activeTab} onValueChange={handleChange} className="w-full">
            <TabsList className="h-auto w-full bg-transparent border-b border-gray-200 rounded-none p-0 justify-start">
                <TabsTrigger
                    value={EReportsTabs.FINANCIAL}
                    className="rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none bg-transparent px-4 py-3 text-gray-500 data-[state=active]:text-indigo-600 font-normal data-[state=active]:font-semibold"
                >
                    Financial
                </TabsTrigger>
                <TabsTrigger
                    value={EReportsTabs.PAYOUTS}
                    className="rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none bg-transparent px-4 py-3 text-gray-500 data-[state=active]:text-indigo-600 font-normal data-[state=active]:font-semibold"
                >
                    Payouts
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
};

export default ReportsTabs;

